const toString = (source) => {
  if (typeof source === 'object') {
    return JSON.stringify(source)
  }

  return source + ''
}

export { toString }
